
import { UserProfile } from "@api/models/UserProfile";
import { ArrayHelpers } from "@common/ArrayHelpers";
import { UserProfileService } from "@share/common/services/dataLoading/userProfiles/UserProfilesService";
import { Vue, Component } from "vue-property-decorator";

@Component({})

export default class UserProfileCollector extends Vue {

    /**
     * service for loading user profiles
     */
    userProfileService: UserProfileService;
    loadedUserIds: number[] = [];
    userProfiles: Record<string, UserProfile> = {};

    updateUsersProfilesList(userIds: number[]) {
        const userIdsForLoad = userIds.filter((userId) => !this.loadedUserIds.includes(userId))
        this.loadUsers(userIdsForLoad);
    }

    async loadUsers(userIds: number[]) {

        if(userIds.length) {
            const userProfilesList = await this.userProfileService.getUserProfiles(userIds);
            const loadedUserIds = userProfilesList.map((userProfile) => userProfile.userId as number);

            this.loadedUserIds = this.loadedUserIds.concat(loadedUserIds);
            this.userProfiles = { ...this.userProfiles, ...(ArrayHelpers.keyBy(userProfilesList, "userId"))};
        }
    }

}

